import React from 'react';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from './mixins/shared/string_constants_mixin';
import FormButton from '../../../components/forms/FormButton';

const createReactClass = require('create-react-class');

const ConnectGoogleButton = createReactClass({
  getInitialState() {
    return {
      googlePlusId: this.props.googlePlusId
    };
  },
  componentDidMount() {
    //   a bit of a hack to call GAPI attachment in React on load
    window.handleGoogleClientLoad = function() {
      ServerCommunicationUtil.initGoogle(this.googleSuccessCallback);
    }.bind(this);
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js?onload=handleGoogleClientLoad';
    script.async = true;
    document.body.appendChild(script);
  },
  googleSuccessCallback(googleUser) {
    const token = googleUser.getAuthResponse().id_token;
    const data = { google_token: token };
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/google/login',
      data,
      function(data, status, xhr) {
        this.setState({ googlePlusId: token });
      }.bind(this),
      console.error,
      function() {}
    );
  },
  handleUnlinkClick() {
    _gaq.push(['_trackEvent', 'Account Settings', 'Google', 'Unlink']);
    ServerCommunicationUtil.postApiEndpoint(
      this.props.unlinkPath,
      {}
    );
  },
  render() {
    let button;
    if (this.state.googlePlusId) {
      button = (
        <li className="mark no-underline">
          <form onSubmit={this.handleUnlinkClick}>
            {StringConstantsMixin.strings.SIGNUP.CONNECTED} (
            <FormButton className="underline unlink" value={StringConstantsMixin.strings.SIGNUP.UNLINK}/>
            )
          </form>
        </li>
      );
    } else {
      button = (
        <a className="account-settings flat-google-btn google">
          <div>
            <span>{StringConstantsMixin.strings.SIGNUP.CONNECT_WITH_GOOGLE}</span>
          </div>
        </a>
      );
    }
    return <ul className="sidebar-facebook">{button}</ul>;
  }
});

export { ConnectGoogleButton };
